export default {"src":"/_next/static/media/logo.423074df.svg","height":59,"width":234,"blurWidth":0,"blurHeight":0};